import { render, staticRenderFns } from "./paperList.vue?vue&type=template&id=69e6f76f&scoped=true&"
import script from "./paperList.vue?vue&type=script&lang=js&"
export * from "./paperList.vue?vue&type=script&lang=js&"
import style0 from "./paperList.vue?vue&type=style&index=0&id=69e6f76f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e6f76f",
  null
  
)

export default component.exports